import { render, staticRenderFns } from "./GoogleDocStep.vue?vue&type=template&id=2520a746&"
import script from "./GoogleDocStep.vue?vue&type=script&lang=js&"
export * from "./GoogleDocStep.vue?vue&type=script&lang=js&"
import style0 from "./GoogleDocStep.vue?vue&type=style&index=0&id=2520a746&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports